import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import CleanedText from 'uikit/CleanedText';
import Icon from 'uikit/Icon';

import styles from './QuestionToApprove.module.scss';

const cx = classNames.bind(styles);

const QuestionToApprove = ({
  handleQuestionVerify,
  position,
  question,
  questionInfo,
}) => (
  <button
    className={cx('container')}
    onClick={handleQuestionVerify}
    type="button"
  >
    <p className={cx('icon')}>
      <img alt="" src={questionInfo.icon} />
    </p>
    <p className={cx('position')}>{position}.</p>
    <CleanedText as="p" className={cx('title')} role="button">
      {question.title}
    </CleanedText>
    <div className={cx('author')}>
      <Icon className={cx('author-icon')} name="user-graduate" />
      <p>{`${(question.author.lastName || 'Unknown').toUpperCase()}, ${
        question.author.firstName || ''
      }`}</p>
    </div>
  </button>
);

QuestionToApprove.propTypes = {
  handleQuestionVerify: PropTypes.func.isRequired,
  position: PropTypes.number.isRequired,
  question: PropTypes.object.isRequired,
  questionInfo: PropTypes.object.isRequired,
};

export default React.memo(QuestionToApprove);
